import api from './index.js'

/**
 * 오르고 현금 출금 신청 (withdraw_request) — 본사 전용.
 * 상품 인출(productWithdrawal.js)과 다른 것이다.
 */
export function getCashWithdrawList(params) {
  return api.get('/api/v1/cash-withdraw', { params })
}

/** 이체 완료 */
export function putCashWithdrawComplete(withdrawId) {
  return api.put(`/api/v1/cash-withdraw/${withdrawId}/complete`)
}

/** 반려 — 묶어 둔 출금액 + 수수료를 회원 원화로 되돌린다 */
export function putCashWithdrawReject(withdrawId, memo) {
  return api.put(`/api/v1/cash-withdraw/${withdrawId}/reject`, { memo })
}
